import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm } from 'formik';
import TextField from '../../../../web-app-components/components/TextField';
import ButtonPrimary from '../../../../web-app-components/components/ButtonPrimary';
import CheckboxField from '../../../../web-app-components/components/CheckboxField';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';

import RouteStartCoordinatesField from './components/RouteStartCoordinatesField';
import GXPFileField from './components/GXPFileField';
import VideoField from './components/VideoField';
import RouteImagesField from './components/RouteImagesField';
import RegionSelectField from '../../../Objects/components/Form/components/RegionSelectField';
import DistrictSelectField from '../../../Objects/components/Form/components/DistrictSelectField';
import ObjectsSelectField from './components/ObjectsSelectField';
import TravelMethodSelectField from './components/TravelMethodSelectField';
import SuitableForSelectField from './components/SuitableForSelectField';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  translationSection: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const getFieldLabel = (fieldName) => {
  const labels = {
    Title: 'Pavadinimas',
    Description: 'Aprašymas',
  };
  return labels[fieldName] ?? fieldName;
};

const Form = ({ isSubmitting, values }) => {
  const classes = useStyles();

  return (
    <FormikForm>
      <div className={classes.root}>
        <RouteStartCoordinatesField name="RouteStartCoordinates" />

        {/* Translation Fields */}
        <Paper className={classes.translationSection} elevation={1}>
          <TextField name="Title" label={getFieldLabel('Title')} fullWidth />
          <TextField
            name="Description"
            label={getFieldLabel('Description')}
            multiline
            rows={4}
            fullWidth
          />
        </Paper>

        <GXPFileField
          name="GXPFile"
          label="Maršruto GXP failas"
          disabled={isSubmitting}
        />

        <VideoField
          name="Video"
          label="Vaizdo įrašas"
          disabled={isSubmitting}
        />

        <RouteImagesField
          name="Images"
          label="Nuotraukos"
          accept="image/*"
          disabled={isSubmitting}
        />

        <TextField name="VideoURL" label="Video nuoroda" fullWidth />

        <RegionSelectField name="Region" label="Regionas" fullWidth />

        <DistrictSelectField name="District" label="Savivaldybė" fullWidth />

        <TextField
          name="Length"
          label="Atstumas"
          type="number"
          fullWidth
          InputProps={{
            endAdornment: <InputAdornment position="end">km</InputAdornment>,
          }}
        />

        <TextField
          name="Duration"
          label="Trukmė"
          fullWidth
          InputProps={{
            endAdornment: <InputAdornment position="end">val.</InputAdornment>,
          }}
        />

        <CheckboxField
          name="VirtualAudioGuideExists"
          label="Virtualus audio gidas"
        />

        <CheckboxField name="Paid" label="Mokamas maršrutas" />

        {values.Paid && (
          <TextField
            name="PaidAmount"
            label="Kaina (€)"
            type="number"
            fullWidth
            inputProps={{ min: 0, step: 0.01 }}
            InputProps={{
              endAdornment: <InputAdornment position="end">€</InputAdornment>,
            }}
          />
        )}

        <SuitableForSelectField name="SuitableFor" label="Skirtas" fullWidth />

        <TravelMethodSelectField
          name="TravelMethod"
          label="Kelionės metodas"
          fullWidth
        />

        <ObjectsSelectField
          name="objects"
          label="Objektai maršrute"
          fullWidth
        />

        <ButtonPrimary type="submit" disabled={isSubmitting}>
          Išsaugoti
        </ButtonPrimary>
      </div>
    </FormikForm>
  );
};

Form.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  values: PropTypes.object,
};

export default Form;
